import { FRIEND_REQUEST, REQUEST_RESPOND, REQUEST_UNFRIEND, REQUEST_CANCEL, DETAIL_USER_FRIEND, SEARCH_FRIEND } from './constants';
import { getAuthHeader } from "../helpers/authHelper";
import { getReq , putReq, postReq} from './rest';
import { handleResponse, loader } from './utils';


export const friendRequest = (friendRequest) => {
    return {
      type: FRIEND_REQUEST,
      friendRequest
    };  
};
export const sendFriendRequest = (params) => {
  
  return (dispatch, getState) => {
    const bodyFormData = new FormData();
    const {login} = getState();
    bodyFormData.set('sender_id', login.user.id);
    bodyFormData.set('receiver_id', params);
    const headers = getAuthHeader();
   // loader(true);
    postReq(`${apiURLPrefix}/userfeed/send_friendrequest`, bodyFormData , headers)
    .then(handleResponse) 
    .then((res) => {
      
      Object.assign(res, {
        searchrow_id   : params
      })
      
      dispatch(friendRequest(res));
    }).catch((err)=>{
      console.log(err);
    }) 
  }  
};

export const requestRespond = (requestRespond) => {
  return {
    type: REQUEST_RESPOND,
    requestRespond
  };  
};
export const userFriendDetail = (friendDetail) => {
  return {
    type: DETAIL_USER_FRIEND,
    friendDetail
  }; 
};
export const respondTorequest = (params) => {
  return (dispatch, getState) => {
    const bodyFormData = new FormData();
    const {login} = getState();
    bodyFormData.set('sender_id', params.sender_id);
    bodyFormData.set('receiver_id', login.user.id);
    bodyFormData.set('status', params.status);
    
    const headers = getAuthHeader();
    //loader(true);
    postReq(`${apiURLPrefix}/userfeed/respondto_friendrequest`, bodyFormData , headers)
    .then(handleResponse) 
    .then((res) => {
      Object.assign(res, {
        status         : params.status,
        sender_id      : params.sender_id,
        searchrow_id   : params.sender_id
      })
      dispatch(requestRespond(res));
     // dispatch(userFriendDetail(frienddetail));
    }).catch((err)=>{
      console.log(err);
    }) 
  }
}

export const requestUnfriend = (requestUnfriend) => {
  return {
    type: REQUEST_UNFRIEND,
    requestUnfriend
  };  
};

export const unfriendRequest = (params) => {
  return (dispatch, getState) => {
    const bodyFormData = new FormData();
    const {login} = getState();
    bodyFormData.set('user_id', login.user.id);
    bodyFormData.set('friend_id', params.friend_id);
    const headers = getAuthHeader();
  //  loader(true);
    postReq(`${apiURLPrefix}/userfeed/unfriend_request`, bodyFormData , headers)
    .then(handleResponse) 
    .then((res) => {
      
        Object.assign(res, {
          searchrow_id   : params.friend_id
        })
     
      dispatch(requestUnfriend(res));
      
    }).catch((err)=>{
      console.log(err);
    }) 
  }
}

export const requestCancel = (requestCancel) => {
  return {
    type: REQUEST_CANCEL,
    requestCancel
  };  
};

export const cancelfriendRequest = (params) => {
  return (dispatch, getState) => {
    const bodyFormData = new FormData();
    const {login} = getState();
    bodyFormData.set('sender_id', login.user.id);
    bodyFormData.set('receiver_id', params.receiver_id);
    const headers = getAuthHeader();
    loader(true);
    postReq(`${apiURLPrefix}/userfeed/cancelfriend_request`, bodyFormData , headers)
    .then(handleResponse) 
    .then((res) => {
      Object.assign(res, {
          searchrow_id   : params.receiver_id
        })
     
      dispatch(requestCancel(res));
    }).catch((err)=>{
      console.log(err);
    }) 
  }
}

export const searchFriend = (searchFriend) => {
  return {
    type: SEARCH_FRIEND,
    searchFriend
  };  
};

export const requestSearchFriend = (params) => {
  return (dispatch, getState) => {
    const bodyFormData = new FormData();
    const {login} = getState();
    bodyFormData.set('user_id', login.user.id);
    bodyFormData.set('counter', 'all');
    bodyFormData.set('search_param', params.search_param);
    const headers = getAuthHeader();
   // loader(true);
    postReq(`${apiURLPrefix}/userfeed/search`, bodyFormData , headers)
    .then(handleResponse) 
    .then((res) => {
      dispatch(searchFriend(res));
    }).catch((err)=>{
      console.log(err);
    }) 
  }
}